import React from 'react';

import { Button } from '@eika/button';
import { CheckmarkAnimation, CheckmarkAnimationTypes } from '@eika/checkmark-animation';
import { Icon, IconTypes } from '@eika/icon';

import type { ApprovalStatus } from '../../../generated-types';
import useTranslation from '../../../hooks/useTranslation';
import CenteredModalContent from '../../shared/CenteredModalContent/CenteredModalContent';
import { ErrorCardWrapper } from '../../shared/ErrorCardWrapper';

import './KidField.scss';

type RequestExceptionWithResponse = import('@eika-infrastruktur/request').RequestExceptionWithResponse;

interface Props {
    paymentStatus?: ApprovalStatus;
    paymentError?: RequestExceptionWithResponse | null;
    retry: () => void;
    onClose: () => void;
}

const UpdateAvtalegiroResult: React.FC<Props> = ({ paymentError, paymentStatus, retry, onClose }) => {
    const translated = useTranslation();
    const infoMessage = translated.avtaleGiroAgreement.deleteAvtaleGiroInfoMessages;

    if (paymentError) {
        return (
            <CenteredModalContent>
                <ErrorCardWrapper exception={paymentError} isModal>
                    <Button onClick={retry}>{translated.ok}</Button>
                </ErrorCardWrapper>
            </CenteredModalContent>
        );
    }

    if (paymentStatus === 'REJECTED') {
        return (
            <CenteredModalContent withMessage>
                <Icon className="wallet-questionmark" type={IconTypes.WALLET_QUESTIONMARK} />
                <h3 className="typography-h3">{infoMessage.error.heading}</h3>
                <p>{infoMessage.error.description}</p>
                <Button onClick={onClose} size="small">
                    {infoMessage.error.check}
                </Button>
            </CenteredModalContent>
        );
    }

    return (
        <CenteredModalContent withMessage>
            <CheckmarkAnimation
                className="transfer-success-checkmark"
                checkmarkAnimationType={CheckmarkAnimationTypes.POSITIVE}
            />
            <h3 className="typography-h3">{infoMessage.success}</h3>
        </CenteredModalContent>
    );
};

export default UpdateAvtalegiroResult;
